import { atom } from 'jotai';

// Pause global refetch triggered by dealUpdated subscription, but only
// when importing coupons via CSV and running the step builder.
export const pauseCouponCsvRefetchState = atom<boolean>(false);
